// import { Spin } from "antd"
import React from "react"
import { BallTriangle } from "react-loader-spinner"
import { Navigate, Router, useRoutes } from "react-router-dom"
import Cartificate from "src/pages/ADMIN/Accounting/Bank/component/Cartificate"
import Credit from "src/pages/ADMIN/Accounting/Bank/component/Credit"
import Payment from "src/pages/ADMIN/Accounting/Fuld/Component/Payment"
import Receipts from "src/pages/ADMIN/Accounting/Fuld/Component/Receipts"
import Debt from "src/pages/ADMIN/Accounting/Bank/component/Debt"
import BillOfSale from "src/pages/ADMIN/Accounting/Bill/BillOfSale"
import Reciept from "src/pages/ADMIN/Accounting/Bill/Reciept"
import SalesReturns from "src/pages/ADMIN/Accounting/Bill/SalesReturns"
import Receipt from "src/pages/ADMIN/Accounting/Warehouse/SimWarehouse/index"
import DeliveryBill from "src/pages/ADMIN/Accounting/Warehouse/ExportWarehouse"

import ROUTER from "."

import ReportByDepartment from "../pages/ADMIN/HumanResource/Work/Report/ReportByDepartment"
import WorkReport from "../pages/ADMIN/HumanResource/Work/Report/WorkReport"
import RecruitmentRequirements from "src/pages/ADMIN/HumanResource/Recruitment"
import CandidateProfile from "src/pages/ADMIN/HumanResource/Recruitment/CandidateProfile"
import InterviewSchedule from "src/pages/ADMIN/HumanResource/Recruitment/InterviewSchedule"
import ReportHR from "src/pages/ADMIN/HumanResource/ReportHR"
import { isMobileConst } from "src/lib/utils"
import SimWareHouse from "src/pages/ADMIN/Accounting/Warehouse/SimWareHouse"
import DataWarehouseIn from "src/pages/ADMIN/Accounting/Warehouse/DataWarehouse"
import ListRequest from "src/pages/ADMIN/Accounting/Warehouse/Proposal"
import DataRequest from "src/pages/ADMIN/Accounting/Warehouse/DataProposal"
import Order from "src/pages/ADMIN/Accounting/Order"
import DepositeWithdrawal from "src/pages/ADMIN/Accounting/DepositWithdrawal"
import AffiliateManager from "src/pages/ADMIN/AffiliateManager"
import HomePage from "src/components/Layouts/LayoutHomePage"
import AffiliateOrder from "src/pages/ADMIN/Accounting/Order/AffiliateOrder"
import SimDetailPage from "src/pages/STAFF/BuySim/SimDetailPage"
import SettingSimPrice from "src/pages/ADMIN/SettingPrice/SettingSimPrice"
import SettingPackagePrice from "src/pages/ADMIN/SettingPrice/SettingPackagePrice"
import NetWorkPackageRequest from "src/pages/ADMIN/NetworkPackageRequest"
import InventoryRepost from "src/pages/ADMIN/Repost/InventoryReport"
import SalesRepost from "src/pages/ADMIN/Repost/SalesReport"
import PurchaseRepost from "src/pages/ADMIN/Repost/PurchaseReport"
import PackagePricing from "src/pages/LEADER/PackagePricing"

import InventoryRepostB2B from "src/pages/LEADER/Repost/InventoryReport"
import SalesRepostB2B from "src/pages/LEADER/Repost/SalesReport"
import PurchaseRepostB2B from "src/pages/LEADER/Repost/PurchaseReport"
import PackagePurchase from "src/pages/LEADER/PackagePurchase"
import ReportPoolWallet from "src/pages/POOL-DATA/ReportPoolWallet"
import ReportReceiptM2M from "src/pages/POOL-DATA/ReportReceiptM2M"
import ReportSaleM2M from "src/pages/POOL-DATA/ReportSaleM2M"

const SubscriptionPackageConfig = React.lazy(() =>
  import("src/pages/POOL-DATA/SubscriptionPackageConfig"),
)

const ReportReconciliation = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportReconciliation"),
)

const GeneralReportPoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/GeneralReport"),
)

const ReportPackageInventoryM2M = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportPackageInventoryM2M"),
)
const ReportInventory = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportInventory"),
)
const OrderDataM2M = React.lazy(() =>
  import("src/pages/POOL-DATA/OrderDataM2M"),
)
const DataReceipt = React.lazy(() =>
  import("src/pages/POOL-DATA/Warehouse/DataReceipt"),
)
const PurchaseReportPoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/PurchaseReport"),
)
const ReportSalePoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/SalesReport"),
)
const ReceiptPoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/Warehouse/Receipt"),
)
const SettingPrice = React.lazy(() =>
  import("src/pages/POOL-DATA/SettingPrice"),
)
const ReportWalletBuy = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportWalletBuy"),
)
const ReportWalletSell = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportWalletSell"),
)
const ReportWalletInventory = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportWalletInventory"),
)
const UserPoolData = React.lazy(() => import("src/pages/ADMIN/UserPoolData"))
const ReportPoolSim = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportPoolSim"),
)
const ManageSoldSim = React.lazy(() => import("src/pages/ADMIN/ManageSoldSim"))
const CustomerPoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/CustomerPoolData"),
)
const OrderPoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/OrderPoolData"),
)
const ReportPoolData = React.lazy(() =>
  import("src/pages/POOL-DATA/ReportPoolData"),
)
const GeneralReportAdmin = React.lazy(() =>
  import("src/pages/ADMIN/Repost/GeneralReport"),
)
const SettingUserDiscount = React.lazy(() =>
  import("src/pages/LEADER/SettingDiscount"),
)
const BuyPackageAnonymous = React.lazy(() =>
  import("src/pages/ANONYMOUS/BuyPackage"),
)
// AMDIN
const UserManagement = React.lazy(() =>
  import("src/pages/ADMIN/UserManagement"),
)
const Questions = React.lazy(() =>
  import("src/pages/ADMIN/QuestionsAndAnswers"),
)
const CountryManager = React.lazy(() =>
  import("src/pages/ADMIN/CountryManager"),
)
// LEADER
const PolicyTerms = React.lazy(() => import("src/pages/LEADER/PolicyTerms"))
const AccountPayment = React.lazy(() => import("src/pages/LEADER/Pay"))
const AccountAgent = React.lazy(() => import("src/pages/LEADER/AgentAccount"))
const BuySimPackage = React.lazy(() => import("src/pages/LEADER/BuySimPackage"))
const SubscriberManagement = React.lazy(() =>
  import("src/pages/LEADER/SubscriberManagement"),
)
const SimManagementSearch = React.lazy(() =>
  import("src/pages/LEADER/SimManagement"),
)
const SimQuantitySold = React.lazy(() =>
  import("src/pages/LEADER/SimQuantitySold"),
)
const PackageSaleType = React.lazy(() =>
  import("src/pages/LEADER/PackageSaleType"),
)
const Groeth = React.lazy(() => import("src/pages/LEADER/Groeth"))
const CustomerTotal = React.lazy(() => import("src/pages/LEADER/CustomerTotal"))
const RevenueTotal = React.lazy(() => import("src/pages/LEADER/RevenueTotal"))
const PackageSold = React.lazy(() => import("src/pages/LEADER/PackageSold"))
const UserManual = React.lazy(() => import("src/pages/LEADER/UserManual"))
const NewSimDataInformation = React.lazy(() =>
  import("src/pages/LEADER/NewSimDataInformation"),
)
const DataManager = React.lazy(() => import("src/pages/LEADER/DataManagerment"))
const HistoryOrder = React.lazy(() => import("src/pages/LEADER/HistoryOrder"))
const AgencyOrder = React.lazy(() => import("src/pages/LEADER/AgencyOrder"))
const RetailReport = React.lazy(() =>
  import("src/pages/LEADER/Repost/RetailReport"),
)
// STAFF
const AccountInfo = React.lazy(() => import("src/pages/COMMON/AccountInfo"))
const AccountUserTerms = React.lazy(() =>
  import("src/pages/STAFF/AccountUserTerms"),
)
const PayMent = React.lazy(() => import("src/pages/STAFF/Payment"))
const BuyPackage = React.lazy(() => import("src/pages/STAFF/BuyPackage"))
const SimPackage = React.lazy(() => import("src/pages/STAFF/BuySim"))
const DashboardB2C = React.lazy(() => import("src/pages/STAFF/DashboardB2C"))
// ANONYMOUS
const PublicRouters = React.lazy(() => import("src/pages/PublicRouters"))
const SvgViewer = React.lazy(() => import("src/pages/SvgViewer"))
const NotFound = React.lazy(() => import("src/pages/NotFound"))
const Home = React.lazy(() => import("src/pages/ANONYMOUS/Home"))
const LoginPage = React.lazy(() => import("src/pages/ANONYMOUS/LoginPage"))
const RegisterPage = React.lazy(() =>
  import("src/pages/ANONYMOUS/RegisterPage"),
)
const InfoAccount = React.lazy(() => import("src/pages/ANONYMOUS/InfoAccount"))
const SettingPermissions = React.lazy(() =>
  import("src/pages/ADMIN/SettingPermissions"),
)
const JourneyOrder = React.lazy(() => import("src/pages/ADMIN/JourneyOrder"))
const CustomerCare = React.lazy(() => import("src/pages/ADMIN/CustomerCare"))

// USER
const PrivateRoutes = React.lazy(() => import("src/pages/PrivateRoutes"))
const ChangePassword = React.lazy(() => import("src/pages/USER/ChangePassword"))

// ADMIN
const AminRoutes = React.lazy(() => import("src/pages/ADMIN/AminRoutes"))
// HR - Nhân sự
const InsuranceDeclaration = React.lazy(() =>
  import("src/pages/ADMIN/InsuranceDeclaration"),
)
const LaborContract = React.lazy(() => import("src/pages/ADMIN/LaborContract"))
const HumanResourceFiles = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Files"),
)
const Salary = React.lazy(() => import("src/pages/ADMIN/Bussiness/salary"))
const WeeklyBonus = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/WeeklyBonus"),
)
const SalaryConfig = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/salary/SalaryConfig"),
)
const HRContract = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Contract"),
)
const HRInsurance = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Insurance"),
)
const HRTimekeeping = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/TimeKeeping"),
)
const HRRewards = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Rewards"),
)
const HRPayroll = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Payroll"),
)
const HREvaluation = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Evaluation"),
)
const HRSynthetic = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Evaluation/Synthetic"),
)
const BussinessOpportunity = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/opportunity"),
)
const BussinessCustomer = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/customer"),
)
const BussinessInventory = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/inventory"),
)
const BussinessSupplier = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/supplier"),
)
const BussinessContract = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/contract"),
)
const BussinessReport = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/Report"),
)
const GeneralReport = React.lazy(() =>
  import("src/pages/LEADER/Repost/GeneralReport"),
)
const Dashboard = React.lazy(() => import("../pages/ADMIN/Dashboard"))
const BussinessProject = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/project"),
)
const BussinessTarget = React.lazy(() =>
  import("src/pages/ADMIN/Bussiness/target"),
)

const AccountInternalContract = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Contract"),
)
const AccountInternalJEntry = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Entry"),
)

const AccountInternalSetting = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Setting"),
)

const Assets = React.lazy(() => import("src/pages/ADMIN/Assets"))

const Assign = React.lazy(() => import("src/pages/ADMIN/Assets/Assign"))

const RequestForm = React.lazy(() =>
  import("src/pages/ADMIN/Assets/RequestForm"),
)
const Statistics = React.lazy(() =>
  import("src/pages/ADMIN/Assets/Depreciation"),
)

// Finance
const FinanceInternal = React.lazy(() =>
  import("src/pages/ADMIN/Finance/Internal"),
)
const FinanceExternal = React.lazy(() =>
  import("src/pages/ADMIN/Finance/External"),
)
const FinanceReport = React.lazy(() => import("src/pages/ADMIN/Finance/Report"))

// Work
const Task = React.lazy(() => import("../pages/ADMIN/HumanResource/Work/Task"))

// Acount -- Asset
const AccountAssetFixed = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Asset/fix"),
)
const AccountAssetToolequit = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Asset/tool-equit"),
)
const AccountSalary = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Salary"),
)
const AccountReport = React.lazy(() =>
  import("src/pages/ADMIN/Accounting/Report"),
)
//--Kế toán thuế
const AccountantTaxSetting = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Setting"),
)
const AccountantTaxAssetFix = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Asset/fix"),
)
const AccountantTaxAssetToolequit = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Asset/tool-equit"),
)
const AccountantTaxSalary = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Salary"),
)
const AccountantTaxContract = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Contract"),
)
const AccountantTaxJEntry = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Entry"),
)
const AccountantTaxReport = React.lazy(() =>
  import("src/pages/ADMIN/AccountantTax/Report"),
)

// Đơn từ
const Application = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Application"),
)

const AssetCharts = React.lazy(() => import("src/pages/ADMIN/Assets/charts"))
const AssetReport = React.lazy(() => import("src/pages/ADMIN/Assets/report"))
const DocumentShare = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Document"),
)
const TargetCompany = React.lazy(() =>
  import("src/pages/ADMIN/HumanResource/Target"),
)

//wsm
const UserManager = React.lazy(() => import("src/pages/ADMIN/UserManagement"))
const AgencyManager = React.lazy(() =>
  import("src/pages/ADMIN/AgencyManagerB2B"),
)
const AgencyManagerB2C = React.lazy(() =>
  import("src/pages/ADMIN/AgencyManagerB2C"),
)
const ContractManagermentCustomer = React.lazy(() =>
  import("src/pages/ADMIN/ContractManagermentCustomer"),
)
const ContractManagermentSupplier = React.lazy(() =>
  import("src/pages/ADMIN/SupplierContractManagement"),
)
const PhonePackage = React.lazy(() => import("src/pages/ADMIN/PhonePackage"))
const SubscriptionFee = React.lazy(() =>
  import("src/pages/ADMIN/SubscriptionFee"),
)
const SimManager = React.lazy(() => import("src/pages/ADMIN/SimManager"))
const PackageManager = React.lazy(() =>
  import("src/pages/ADMIN/PackageManager"),
)
const NetworkPackage = React.lazy(() =>
  import("src/pages/ADMIN/NetworkPackage"),
)
const CustomerManagement = React.lazy(() =>
  import("src/pages/ADMIN/CustomerManagement"),
)
const SupplierManagement = React.lazy(() =>
  import("src/pages/ADMIN/SupplierManagement"),
)
const SuggestedWarehouse = React.lazy(() =>
  import("src/pages/ADMIN/SuggestedWarehouse"),
)
const SaleSettingReport = React.lazy(() =>
  import("src/pages/LEADER/Repost/SaleSettingReport"),
)

const Billing = React.lazy(() => import("src/pages/ADMIN/Billing"))
const Network = React.lazy(() => import("src/pages/ADMIN/NetworkManager"))

function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          <BallTriangle
            height={50}
            width={50}
            radius={5}
            color="#01638d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}

const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.HOME_PAGE_CUSTOMER,
    element: (
      <LazyLoadingComponent>
        <HomePage />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DETAIL_SIM,
    element: (
      <LazyLoadingComponent>
        <SimDetailPage />
      </LazyLoadingComponent>
    ),
  },
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    // Hồ sơ nhân sự
    children: [
      // ADMIN
      {
        path: ROUTER.USER_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <UserManagement />
          </LazyLoadingComponent>
        ),
      },
      // báo cáo tổng quát
      {
        path: ROUTER.GENERAL_REPORT_ADMIN,
        element: (
          <LazyLoadingComponent>
            <GeneralReportAdmin />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.COUNTRY_MANAGER,
        element: (
          <LazyLoadingComponent>
            <CountryManager />
          </LazyLoadingComponent>
        ),
      },
      //order
      {
        path: ROUTER.ACCOUNT_ORDER,
        element: (
          <LazyLoadingComponent>
            <Order />
          </LazyLoadingComponent>
        ),
      },
      // DEPOSITE AND WITHDRAWAL
      {
        path: ROUTER.ACCOUNT_DEPOSITE_WITHDRAWAL,
        element: (
          <LazyLoadingComponent>
            <DepositeWithdrawal />
          </LazyLoadingComponent>
        ),
      },
      // AFFILIATE_MANAGER
      {
        path: ROUTER.AFFILIATE_MANAGER,
        element: (
          <LazyLoadingComponent>
            <AffiliateManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.AFFILIATE_ORDER,
        element: (
          <LazyLoadingComponent>
            <AffiliateOrder />
          </LazyLoadingComponent>
        ),
      },
      // setting price
      {
        path: ROUTER.SETTING_SIM_PRICE,
        element: (
          <LazyLoadingComponent>
            <SettingSimPrice />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SETTING_PACKAGE_PRICE,
        element: (
          <LazyLoadingComponent>
            <SettingPackagePrice />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LIST_PACKAGE_REQUEST,
        element: (
          <LazyLoadingComponent>
            <NetWorkPackageRequest />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.INVENTORY_REPORT,
        element: (
          <LazyLoadingComponent>
            <InventoryRepost />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PURCHASE_REPORT,
        element: (
          <LazyLoadingComponent>
            <PurchaseRepost />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SALES_REPORT,
        element: (
          <LazyLoadingComponent>
            <SalesRepost />
          </LazyLoadingComponent>
        ),
      },

      // LEADER
      {
        path: ROUTER.HISTORY_ORDER,
        element: (
          <LazyLoadingComponent>
            <HistoryOrder />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.GENERAL_REPORT_B2B,
        element: (
          <LazyLoadingComponent>
            <GeneralReport />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.INVENTORY_REPORT_B2B,
        element: (
          <LazyLoadingComponent>
            <InventoryRepostB2B />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PURCHASE_REPORT_B2B,
        element: (
          <LazyLoadingComponent>
            <PurchaseRepostB2B />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SALES_REPORT_B2B,
        element: (
          <LazyLoadingComponent>
            <SalesRepostB2B />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.RETAIL_REPORT_B2B,
        element: (
          <LazyLoadingComponent>
            <RetailReport />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PACKAGE_PURCHASE,
        element: (
          <LazyLoadingComponent>
            <PackagePurchase />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PACKAGE_SALE_TYPE,
        element: (
          <LazyLoadingComponent>
            <PackageSaleType />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SALE_SETTING_REPORT,
        element: (
          <LazyLoadingComponent>
            <SaleSettingReport />
          </LazyLoadingComponent>
        ),
      },

      // STAFF

      {
        path: ROUTER.ACCOUNT_INFO,
        element: (
          <LazyLoadingComponent>
            <AccountInfo />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DASHBOARDB2C,
        element: (
          <LazyLoadingComponent>
            <DashboardB2C />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.USER_TERMS,
        element: (
          <LazyLoadingComponent>
            <AccountUserTerms />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.PAYMENT,
        element: (
          <LazyLoadingComponent>
            <PayMent />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SALES_BUY_PACKAGE,
        element: (
          <LazyLoadingComponent>
            <BuyPackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SALES_BUY_SIM,
        element: (
          <LazyLoadingComponent>
            <SimPackage />
          </LazyLoadingComponent>
        ),
      },
      // HR -- Nhân sự

      {
        path: ROUTER.HR_FILES,
        element: (
          <LazyLoadingComponent>
            <HumanResourceFiles />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SALARY,
        element: (
          <LazyLoadingComponent>
            <Salary />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.WEEKLY_BONUS,
        element: (
          <LazyLoadingComponent>
            <WeeklyBonus />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CUSTOMER_CARE,
        element: (
          <LazyLoadingComponent>
            <CustomerCare />
          </LazyLoadingComponent>
        ),
      },

      //WSM -- Admin
      {
        path: ROUTER.UserManager,
        element: (
          <LazyLoadingComponent>
            <UserManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.AgencyManager,
        element: (
          <LazyLoadingComponent>
            <AgencyManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.AgencyManagerB2C,
        element: (
          <LazyLoadingComponent>
            <AgencyManagerB2C />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CONTRACT_MANAGERMENT_CUSTOMER,
        element: (
          <LazyLoadingComponent>
            <ContractManagermentCustomer />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CONTRACT_MANAGERMENT_SUPPLIER,
        element: (
          <LazyLoadingComponent>
            <ContractManagermentSupplier />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHONE_PACKAGE,
        element: (
          <LazyLoadingComponent>
            <PhonePackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NETWORK_MANAGER,
        element: (
          <LazyLoadingComponent>
            <Network />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SUBSCRIPTION_FEE,
        element: (
          <LazyLoadingComponent>
            <SubscriptionFee />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SIM_MANAGER,
        element: (
          <LazyLoadingComponent>
            <SimManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PACKAGE_MANAGER,
        element: (
          <LazyLoadingComponent>
            <PackageManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NetworkPackage,
        element: (
          <LazyLoadingComponent>
            <NetworkPackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CUSTOMER_MANAGERMENT,
        element: (
          <LazyLoadingComponent>
            <CustomerManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SUPPLIER_MANAGERMENT,
        element: (
          <LazyLoadingComponent>
            <SupplierManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SUGGESTED_WAREHOUSE,
        element: (
          <LazyLoadingComponent>
            <SuggestedWarehouse />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.BILLING,
        element: (
          <LazyLoadingComponent>
            <Billing />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.SALARY_CONFIG,
        element: (
          <LazyLoadingComponent>
            <SalaryConfig />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUESTIONS_AND_ANSWERS,
        element: (
          <LazyLoadingComponent>
            <Questions />
          </LazyLoadingComponent>
        ),
      },

      // Hợp đồng bảo hiểm
      // {
      //   path: ROUTER.INSURANCE_DECLARATION,
      //   element: (
      //     <LazyLoadingComponent>
      //       <InsuranceDeclaration />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.LABOR_CONTRACT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <LaborContract />
      //     </LazyLoadingComponent>
      //   ),
      // },

      //WSM -- Leader
      {
        path: ROUTER.ACCOUNT_TERMS,
        element: (
          <LazyLoadingComponent>
            <PolicyTerms />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_PAYMENT,
        element: (
          <LazyLoadingComponent>
            <AccountPayment />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.AGENT_ACCOUNT_CREATE,
        element: (
          <LazyLoadingComponent>
            <AccountAgent />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.AGENT_SIM_PACKAGE_SERVICE,
        element: (
          <LazyLoadingComponent>
            <BuySimPackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PACKAGE_MANAGEMENT_SEARCH,
        element: (
          <LazyLoadingComponent>
            <SubscriberManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SIM_MANAGER_SEARCH,
        element: (
          <LazyLoadingComponent>
            <SimManagementSearch />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DATA_MANAGER,
        element: (
          <LazyLoadingComponent>
            <DataManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REVENUE_SIM_QUANTITY_SOLD,
        element: (
          <LazyLoadingComponent>
            <SimQuantitySold />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REVENUE_SIM_QUANTITY_SOLD,
        element: (
          <LazyLoadingComponent>
            <SimQuantitySold />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.GROETH,
        element: (
          <LazyLoadingComponent>
            <Groeth />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REVENUE_TOTAL,
        element: (
          <LazyLoadingComponent>
            <RevenueTotal />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REVENUE_CUSTOMER_TOTAL,
        element: (
          <LazyLoadingComponent>
            <CustomerTotal />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REVENUE_PACKAGE_SOLD,
        element: (
          <LazyLoadingComponent>
            <PackageSold />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.USER_MANUAL,
        element: (
          <LazyLoadingComponent>
            <UserManual />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NEW_SIM_DATA_INFORMATION,
        element: (
          <LazyLoadingComponent>
            <NewSimDataInformation />
          </LazyLoadingComponent>
        ),
      },

      // {
      //   path: ROUTER.HR_CONTRACT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HRContract />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.HR_INSURANCE,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HRInsurance />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.HR_TIMEKEEPING,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HRTimekeeping />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.HR_REWARDS,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HRRewards />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // // Nhân sự -> Bảng lương
      // {
      //   path: ROUTER.HR_PAYROLL,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HRPayroll />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // // Nhân sự -> Đánh giá
      // {
      //   path: ROUTER.HR_EVALUATION,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HREvaluation />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.HR_EVALUATION_SYNTHETIC,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HRSynthetic />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // // Nhân sự  -> Tuyển dụng
      // // Yêu cầu tuyển dụng
      // {
      //   path: ROUTER.HR_JOB_REQUESTS,
      //   element: (
      //     <LazyLoadingComponent>
      //       <RecruitmentRequirements />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // // hồ sơ ứng viên
      // {
      //   path: ROUTER.HR_CANDIDATE_PROFILES,
      //   element: (
      //     <LazyLoadingComponent>
      //       <CandidateProfile />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // // lịch phỏng vấn
      // {
      //   path: ROUTER.HR_INTERVIEW_SCHEDULES,
      //   element: (
      //     <LazyLoadingComponent>
      //       <InterviewSchedule />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // // Nhân sự -> Báo cáo
      // {
      //   path: ROUTER.HR_REPORT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <ReportHR />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // Nhân sự -> Đơn từ
      // {
      //   path: `${ROUTER.APPLICATION}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <Application />
      //     </LazyLoadingComponent>
      //   ),
      // },
      //  Nhân sự -> Công việc
      // {
      //   path: ROUTER.WORK_TASK,
      //   element: (
      //     <LazyLoadingComponent>
      //       <Task />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.WORK_TASK_JOB,
      //   element: (
      //     <LazyLoadingComponent>
      //       <WorkReport />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.WORK_TASK_STAFF,
      //   element: (
      //     <LazyLoadingComponent>
      //       <ReportByEmployee />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.WORK_TASK_DEPARTMENT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <ReportByDepartment />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // Nhân sự -> Mục tiêu
      // {
      //   path: ROUTER.TARGET,
      //   element: (
      //     <LazyLoadingComponent>
      //       <TargetCompany />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // Nhân sự -> Tài liệu
      // {
      //   path: `${ROUTER.DOCUMENT}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <DocumentShare />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.BUSSINESS_OPPORTUNITY,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BussinessOpportunity />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.BUSSINESS_CUSTOMER,
        element: (
          <LazyLoadingComponent>
            <BussinessCustomer />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: `${ROUTER.BUSSINESS_INVENTORY}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BussinessInventory />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.BUSSINESS_SUPPLIER,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BussinessSupplier />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.BUSSINESS_CONTRACT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BussinessContract />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        // path: `${ROUTER.BUSSINESS_ORDER}/:mode`,
        path: `${ROUTER.REPORT}/:mode`,
        element: (
          <LazyLoadingComponent>
            <BussinessReport />
          </LazyLoadingComponent>
        ),
      },
      {
        // path: `${ROUTER.BUSSINESS_ORDER}/:mode`,
        path: ROUTER.DASHBOARD,
        element: (
          <LazyLoadingComponent>
            <Dashboard />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: ROUTER.BUSSINESS_PROJECT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BussinessProject />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: `${ROUTER.BUSSINESS_TARGET}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BussinessTarget />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // FINANCE - Tài chính
      // {
      //   path: ROUTER.FINANCE_INTERNAL,
      //   element: (
      //     <LazyLoadingComponent>
      //       <FinanceInternal />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.FINANCE_EXTERNAL,
      //   element: (
      //     <LazyLoadingComponent>
      //       <FinanceExternal />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: ROUTER.FINANCE_REPORT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <FinanceReport />
      //     </LazyLoadingComponent>
      //   ),
      // },

      //-- Kế toán nội bộ -> Tiền lương
      // {
      //   path: `${ROUTER.ACCOUNT_INTERNAL_SALARY}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountSalary />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // //-- Kế toán nội bộ -> Tài sản
      // {
      //   path: `${ROUTER.ACCOUNT_INTERNAL_ASSET_FIX}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountAssetFixed />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // {
      //   path: `${ROUTER.ACCOUNT_INTERNAL_ASSET_TOOLEQUIT}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountAssetToolequit />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // //-- Kế toán nội bộ -> Hợp đồng
      // {
      //   path: `${ROUTER.ACCOUNT_INTERNAL_CONTRACT}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountInternalContract />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // //-- Kế toán nội bộ -> Bút toán
      // {
      //   path: `${ROUTER.ACCOUNT_INTERNAL_JOURNAL_ENTRY}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountInternalJEntry />
      //     </LazyLoadingComponent>
      //   ),
      // },
      // //-- Kế toán nội bộ -> Báo cáo
      // {
      //   path: ROUTER.ACCOUNT_INTERNAL_REPORT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountReport />
      //     </LazyLoadingComponent>
      //   ),
      // },

      // Phiếu thu phiếu chi
      // {
      //   path: ROUTER.ACCOUNT_FINANCE_INTERNAL,
      //   element: (
      //     <LazyLoadingComponent>
      //       <Payment />
      //     </LazyLoadingComponent>
      //   ),
      // },
      //-- Kế toán nội bộ -> Cài đặt
      // {
      //   path: `${ROUTER.ACCOUNT_INTERNAL_SETTING}/:mode`,
      //   element: (
      //     <LazyLoadingComponent>
      //       <AccountInternalSetting />
      //     </LazyLoadingComponent>
      //   ),
      // },

      {
        path: `${ROUTER.ACCOUNT_TAX_SETTING}/:mode`,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxSetting />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.ACCOUNT_TAX_ASSET_FIX}/:mode`,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxAssetFix />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.ACCOUNT_TAX_ASSET_TOOLEQUIT}/:mode`,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxAssetToolequit />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.ACCOUNT_TAX_SALARY}/:mode`,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxSalary />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.ACCOUNT_TAX_CONTRACT}/:mode`,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxContract />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.ACCOUNT_TAX_JOURNAL_ENTRY}/:mode`,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxJEntry />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_TAX_REPORT,
        element: (
          <LazyLoadingComponent>
            <AccountantTaxReport />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_FINANCE_EXTERNAL,
        element: (
          <LazyLoadingComponent>
            <Receipts />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_FINANCE_DEBT,
        element: (
          <LazyLoadingComponent>
            <Debt />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_FINANCE_CREDIT,
        element: (
          <LazyLoadingComponent>
            <Credit />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_FINANCE_CARTIFICATE,
        element: (
          <LazyLoadingComponent>
            <Cartificate />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ASSET_CHART,
        element: (
          <LazyLoadingComponent>
            <AssetCharts />
          </LazyLoadingComponent>
        ),
      },
      // kế toán nội bộ/Hóa đơn
      {
        path: ROUTER.ACCOUNT_FINANCE_SALES_INVOICE,
        element: (
          <LazyLoadingComponent>
            <BillOfSale />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_FINANCE_PURCHASE_INVOICE,
        element: (
          <LazyLoadingComponent>
            <Reciept />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT_FINANCE_RETURNED_GOODS,
        element: (
          <LazyLoadingComponent>
            <SalesReturns />
          </LazyLoadingComponent>
        ),
      },
      // PHIẾU ĐỀ XUẤT
      {
        path: ROUTER.ACCOUNT_LIST_REQUEST,
        element: (
          <LazyLoadingComponent>
            <ListRequest />
          </LazyLoadingComponent>
        ),
      },

      // Kho
      // Phiếu xuất kho
      {
        path: ROUTER.ACCOUNT_WAREHOUSE_OUT,
        element: (
          <LazyLoadingComponent>
            <DeliveryBill />
          </LazyLoadingComponent>
        ),
      },
      // Phiếu nhập kho sim
      {
        path: ROUTER.ACCOUNT_WAREHOUSE_IN,
        element: (
          <LazyLoadingComponent>
            <Receipt />
          </LazyLoadingComponent>
        ),
      },
      // Nhập kho data
      {
        path: ROUTER.ACCOUNT_WAREHOUSE_IN_DATA,
        element: (
          <LazyLoadingComponent>
            <DataWarehouseIn />
          </LazyLoadingComponent>
        ),
      },
      // Quản lý kho sim
      {
        path: ROUTER.ACCOUNT_SIM_WAREHOUSE,
        element: (
          <LazyLoadingComponent>
            <SimWareHouse />
          </LazyLoadingComponent>
        ),
      },
      //PHIẾU ĐỀ XUẤT DATA
      {
        path: ROUTER.ACCOUNT_DATA_REQUEST,
        element: (
          <LazyLoadingComponent>
            <DataRequest />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SETTING_PERMISSIONS,
        element: (
          <LazyLoadingComponent>
            <SettingPermissions />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LIST_ORDER_AGENCY_CHILD,
        element: (
          <LazyLoadingComponent>
            <AgencyOrder />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PACKAGE_PRICING,
        element: (
          <LazyLoadingComponent>
            <PackagePricing />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SETTING_DISCOUNT,
        element: (
          <LazyLoadingComponent>
            <SettingUserDiscount />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.BUY_PACKAGE_ANONYMOUS,
        element: (
          <LazyLoadingComponent>
            <BuyPackageAnonymous />
          </LazyLoadingComponent>
        ),
      },
      // pool data
      {
        path: ROUTER.SOLD_SIM_CARDS,
        element: (
          <LazyLoadingComponent>
            <ManageSoldSim />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CUSTOMER_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <CustomerPoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ORDER_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <OrderPoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ORDER_DATA_M2M,
        element: (
          <LazyLoadingComponent>
            <OrderDataM2M />
          </LazyLoadingComponent>
        ),
      },
      // report pool data
      {
        path: ROUTER.REPORT_RECONCILIATION_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <ReportReconciliation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <ReportPoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_SIM,
        element: (
          <LazyLoadingComponent>
            <ReportPoolSim />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_WALLET,
        element: (
          <LazyLoadingComponent>
            <ReportPoolWallet />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_DATA_WALLET_BUY,
        element: (
          <LazyLoadingComponent>
            <ReportWalletBuy />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_DATA_WALLET_SELL,
        element: (
          <LazyLoadingComponent>
            <ReportWalletSell />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_DATA_WALLET_INVENTORY,
        element: (
          <LazyLoadingComponent>
            <ReportWalletInventory />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_DATA_PURCHASE,
        element: (
          <LazyLoadingComponent>
            <PurchaseReportPoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_POOL_DATA_SALE,
        element: (
          <LazyLoadingComponent>
            <ReportSalePoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.GENERAL_REPORT_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <GeneralReportPoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_INVENTORY_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <ReportInventory />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_PACKAGE_INVENTORY_M2M,
        element: (
          <LazyLoadingComponent>
            <ReportPackageInventoryM2M />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.POOL_DATA_USER_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <UserPoolData />
          </LazyLoadingComponent>
        ),
      },
      // PHIẾU NHẬP KHO POOL DATA
      {
        path: ROUTER.RECEIPT_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <ReceiptPoolData />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DATA_RECEIPT_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <DataReceipt />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_RECEIPT_M2M,
        element: (
          <LazyLoadingComponent>
            <ReportReceiptM2M />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.REPORT_ORDER_M2M,
        element: (
          <LazyLoadingComponent>
            <ReportSaleM2M />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.SETTING_PRICE_POOL_DATA,
        element: (
          <LazyLoadingComponent>
            <SettingPrice />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SUBSCRIPTION_PACKAGE_CONFIG,
        element: (
          <LazyLoadingComponent>
            <SubscriptionPackageConfig />
          </LazyLoadingComponent>
        ),
      },

    ],
  },
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.DOI_MAT_KHAU,
        element: (
          <LazyLoadingComponent>
            <ChangePassword />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.HOME_PAGE,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ROOT,
        element: (
          <LazyLoadingComponent>
            {isMobileConst ? (
              <Navigate to={ROUTER.BUSSINESS_CONTACT} />
            ) : (
              <Navigate to={ROUTER.DASHBOARD} />
            )}
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT,
        element: (
          <LazyLoadingComponent>
            <InfoAccount />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SEARCH_JOURNEY_ORDER,
        element: (
          <LazyLoadingComponent>
            <JourneyOrder />
          </LazyLoadingComponent>
        ),
      },
    ],
  },

  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      // {
      //   path: ROUTER.HOME,
      //   element: (
      //     <LazyLoadingComponent>
      //       <Home />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.DANG_NHAP,
        element: (
          <LazyLoadingComponent>
            <LoginPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY,
        element: (
          <LazyLoadingComponent>
            <RegisterPage />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
